export const GET_USER_ACCOUNT_DATA = 'userAccount/GET_USER_ACCOUNT_DATA';
export const GET_USER_ACCOUNT_DATA_SUCCESSFUL =
  'userAccount/GET_USER_ACCOUNT_DATA_SUCCESSFUL';
export const GET_USER_ACCOUNT_DATA_FAILED =
  'userAccount/GET_USER_ACCOUNT_DATA_FAILED';
export const ADD_CUSTOM_CABINET = 'userAccount/ADD_CUSTOM_CABINET';
